import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TTenkenSeibiListGetReq,
  TTenkenSeibiListGetRes,
  TTenkenSeibiPostReq,
  TTenkenSeibiPutReq,
  TTenkenSeibihiListGetReq,
  TTenkenSeibihiListGetRes,
  TSyaryoTenkenList,
} from "./TTenken"

/**
 * 点検整備に対するAPIリクエスト用サービス
 *
 * @export
 * @class TenkenService
 * @extends {ConnectApi}
 */
export default class TenkenService extends ConnectApi {
  /**
   * 点検整備 一覧取得
   *
   * @param {TTenkenSeibiListGetReq} params
   * @memberof TenkenService
   */
  getList = async (params: TTenkenSeibiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkenSeibiListGetRes[]>> =
        await this.getInner(`/truck/tenkenseibi/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点検整備単体 取得
   *
   * @param {number} id
   * @memberof TenkenService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoTenkenList>> =
        await this.getInner(`truck/tenkenseibi/list/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点検整備共用 更新
   *
   * @param {TTenkenSeibiPutReq} data
   * @memberof TenkenService
   */
  put = async (id: number, data: TTenkenSeibiPutReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/tenkenseibi/list/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点検整備共用 登録
   *
   * @param {TTenkenSeibiPostReq} data
   * @memberof TenkenService
   */
  post = async (data: TTenkenSeibiPostReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `truck/tenkenseibi/list`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点検整備費 一覧取得
   *
   * @param {TTenkenSeibihiListGetReq} params
   * @memberof TenkenService
   */
  getSeibihiList = async (params: TTenkenSeibihiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkenSeibihiListGetRes[]>> =
        await this.getInner(`/truck/tenkenseibihi/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
